import PropTypes from 'prop-types';
import styles from './SnackBars.module.scss';

const SnackBars = ({ children, anchorOrigin, ...props }) => {
    const { vertical, horizontal } = anchorOrigin;
    return (
        <div
            className={[
                styles.container,
                styles[vertical],
                styles[horizontal]
            ].join(' ')}
            {...props}
        >
            {children}
        </div>
    );
};

SnackBars.propTypes = {
    children: PropTypes.any,
    anchorOrigin: PropTypes.object,
    'data-testid': PropTypes.string
};

SnackBars.defaultProps = {
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'left'
    }
};

export default SnackBars;
